import type { VehicleLocationDto } from '@/lib/sanity/dto';
import { stegaClean } from '@/lib/utils/stega';

/**
 * The Business Profile that sells a vehicle: the location listing its brand,
 * otherwise the first one (vehicleSettings.locations). Page, JSON-LD and feed
 * all resolve it here, so the store code always matches the shown dealer.
 */
export function vehicleLocation(
    locations: VehicleLocationDto[] | null | undefined,
    makeId?: string,
): VehicleLocationDto | undefined {
    const list = stegaClean(locations) ?? [];
    const brandId = stegaClean(makeId);

    return (brandId && list.find((location) => location.brandIds?.includes(brandId))) || list[0];
}
